export const genres = window.SITE_CONFIG.GENRE_TAGS
export const moods = window.SITE_CONFIG.MOOD_TAGS
export const instruments = window.SITE_CONFIG.INSTRUMENT_TAGS
export const roles = window.SITE_CONFIG.SONG_ROLES

export const reportReasons = [
  'Spam', 'Sexual content', 'Hate speech or violence', 'Harassment or bullying', 'Mark explicit content'
]

const thumbs = {
  genre: {
    'Alternative': 'alternative_thumbnail.jpg',
    'Ambient Sounds': 'ambient_sounds_thumbnail.jpg',
    'Christian': 'christian_thumbnail.jpg',
    'Classical': 'classical_thumbnail.jpg',
    'Country': 'country_thumbnail.jpg',
    'Disco': 'disco_thumbnail.png',
    'Easy Listening': 'easy_listening_thumbnail.jpg',
    'Electronic/Dance': 'electronic_dance_thumbnail.png',
    'Folk & Acoustic': 'folk_and_acoustic_thumbnail.jpg',
    'Funk': 'funk_thumbnail.jpg',
    'Hip Hop': 'hip_hop_thumbnail.jpg',
    'Jazz & Blues': 'jazz_blues_thumbnail.png',
    'Latin': 'latin_thumbnail.jpg',
    'Lounge': 'lounge_thumbnail.jpg',
    'Metal': 'metal_thumbnail.png',
    'Pop': 'pop_thumbnail.jpg',
    'Punk': 'punk_thumbnail.jpg',
    'R&B': 'r_b_thumbnail.jpg',
    'Reggae': 'reggae_thumbnail.jpg',
    'Rock': 'rock_thumbnail.png',
    'Soul': 'soul_thumbnail.jpg',
    'All Other': 'all_other_thumbnail.png'
  },
  mood: {
    'Bold/Dramatic': 'bold-dramatic_thumbnail.jpg',
    'Relax/Hangout': 'relax-hang-out_thumbnail.jpg',
    'Calm/Meditative': 'calm-meditative_thumbnail.jpg',
    'Edgy/Tense': 'edgy-tense_thumbnail.png',
    'Fun/Goofy': 'fun-goofy_thumbnail.jpg',
    'Happy/Energized': 'happy_energized_thumbnail.jpg',
    'Heartbroken/Sad': 'heartbroken-sad_thumbnail.jpg',
    'Inspirational/Moving': 'inspirational-moving_thumbnail.png',
    'Sentimental/In Love': 'sentimental-in-love_thumbnail.jpg'
  },
  instrument: {
    'Acoustic Guitar': 'acoustic_guitar_thumbnail.png',
    'Acoustic Piano': 'acoustic_piano_thumbnail.png',
    'Bass': 'bass_thumbnail.png',
    'Brass': 'brass_thumbnail.png',
    'Drums': 'drums_thumbnail.png',
    'Electric Guitar': 'electric_guitar_thumbnail.png',
    'Electronic Sounds': 'electronic_sounds_thumbnail.png',
    'Keyboard/Organ': 'keyboard-organ_thumbnail.png',
    'Other': 'other_instruments_thumbnail.png',
    'Percussion': 'percussion_thumbnail.png',
    'Strings': 'strings_thumbnail.png',
    'Turntable/DJ': 'turntable-dj_thumbnail.png',
    'Woodwinds': 'woodwinds_thumbnail.png'
  }
}

const heros = {
  genre: {
    'Alternative': 'alternative_hero.jpg',
    'Ambient Sounds': 'ambient_sounds_hero.jpg',
    'Christian': 'christian_hero.jpg',
    'Classical': 'classical_hero.jpg',
    'Country': 'country_hero.jpg',
    'Disco': 'disco_hero.jpg',
    'Easy Listening': 'easy_listening_hero.jpg',
    'Electronic/Dance': 'electronic_dance_hero.jpg',
    'Folk & Acoustic': 'folk_and_acoustic_hero.jpg',
    'Funk': 'funk_hero.jpg',
    'Hip Hop': 'hip_hop_hero.jpg',
    'Jazz & Blues': 'jazz_blues_hero.jpg',
    'Latin': 'latin_hero.jpg',
    'Lounge': 'lounge_hero.jpg',
    'Metal': 'metal_hero.jpg',
    'Pop': 'pop_hero.jpg',
    'Punk': 'punk_hero.jpg',
    'R&B': 'r_b_hero.jpg',
    'Reggae': 'reggae_hero.jpg',
    'Rock': 'rock_hero.jpg',
    'Soul': 'soul_hero.jpg',
    'All Other': 'all_other_hero.jpg'
  },
  mood: {
    'Bold/Dramatic': 'bold-dramatic_hero.jpg',
    'Relax/Hangout': 'relax-hang-out_hero.jpg',
    'Calm/Meditative': 'calm-meditative_hero.jpg',
    'Edgy/Tense': 'edgy-tense_hero.jpg',
    'Fun/Goofy': 'fun_goofy_hero.jpg',
    'Happy/Energized': 'happy_energized_hero.jpg',
    'Heartbroken/Sad': 'heartbroken-sad_hero.jpg',
    'Inspirational/Moving': 'inspirational-moving_hero.jpg',
    'Sentimental/In Love': 'sentimental-in-love_hero.jpg'
  },
  instrument: {
    'Acoustic Guitar': 'acoustic_guitar_hero.jpg',
    'Acoustic Piano': 'acoustic_piano_hero.jpg',
    'Bass': 'bass_hero.jpg',
    'Brass': 'brass_hero.jpg',
    'Drums': 'drums_hero.jpg',
    'Electric Guitar': 'electric_guitar_hero.jpg',
    'Electronic Sounds': 'electronic_sounds_hero.jpg',
    'Keyboard/Organ': 'keyboard-organ_hero.jpg',
    'Percussion': 'percussion_hero.jpg',
    'Strings': 'strings_hero.jpg',
    'Turntable/DJ': 'turntable-dj_hero.jpg',
    'Woodwinds': 'woodwinds_hero.jpg',
    'Other': 'other_instruments_hero.jpg'
  }
}

// transparent 1x1 PNG to use as the thumb/hero fallback
export const EMPTY_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGP6zwAAAgcBApocMXEAAAAASUVORK5CYII='
// transparent 16x9 PNG to use as a video thumbnail fallback in feed (to maintain aspect ratio)
export const EMPTY_IMAGE_16_9 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAAXNSR0IArs4c6QAAABFJREFUKBVjYBgFoyFAhRAAAAJJAAFEkgypAAAAAElFTkSuQmCC'

function getImage (type, category, tag) {
  if (!tag) return EMPTY_IMAGE
  const images = type[category]
  if (!images) return EMPTY_IMAGE
  const img = images[tag]
  return img ? `/static/img/${category}s/${img}` : EMPTY_IMAGE
}

export function getThumbnail (category, tag) {
  return getImage(thumbs, category, tag)
}

export function getHero (category, tag) {
  return getImage(heros, category, tag)
}



// WEBPACK FOOTER //
// ./src/store/modules/tag.js